<script setup>
import { useWishlistStore } from '@/stores/wishlist.js'
import { storeToRefs } from 'pinia'
import { defineAsyncComponent } from 'vue'

const Badge = defineAsyncComponent(
  () => import('@/components/basic/atoms/Badge.vue')
)
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)

const wishlistStore = useWishlistStore()
const { totalCount } = storeToRefs(wishlistStore)
</script>

<template>
  <div class="d-flex flex-md-column">
    <div class="d-flex justify-center">
      <span class="d-inline-flex position-relative">
        <SvgWrapper use="icon_svg_heart" :dimensions="34" />
        <Badge v-if="totalCount" :text="totalCount" :class="'wishlist-count'" />
      </span>
    </div>
    <span class="text-uppercase d-none d-md-flex font-size-s pb-1">
      {{ translate('new_cart_page_wishlist') }}
    </span>
  </div>
</template>
